import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import config from '../../config';

const useStyles = makeStyles(() => ({
	container: {
		minHeight: '100vh',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		padding: '0 24px',
		color: 'white',
	},
	icon: {
		width: 80,
		height: 80,
		marginBottom: 24,
	},
	header: {
		fontSize: 22,
		fontWeight: 600,
		marginBottom: 12,
	},
	subHeader: {
		fontSize: 16,
		fontWeight: 400,
		opacity: 0.85,
		lineHeight: 1.5,
	},
	retryBtn: {
		marginTop: 32,
		background: '#bfd730',
		color: 'black',
		textTransform: 'none',
		fontSize: 14,
		fontWeight: 'bold',
		padding: '6px 24px',
		boxShadow: '0px 1px 5px 0px',
		'&:hover': {
			background: '#a8be2a',
		},
	},
}));

const Maintenance = () => {
	const classes = useStyles();
	const { header, sub_header } = config.maintenance || {};

	return (
		<div className={classes.container}>
			<img
				className={classes.icon}
				src='/images/order-processing-icon.svg'
				alt='maintenance'
			/>
			<div className={classes.header}>{header || 'System Under Maintenance'}</div>
			<div className={classes.subHeader}>{sub_header || 'We are working on it. Please check back shortly.'}</div>
			<Button
				variant='contained'
				className={classes.retryBtn}
				onClick={() => window.location.reload()}
			>
				Check Again
			</Button>
		</div>
	);
};

export default Maintenance;
